
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 210.68 210.68"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M205.613 30.693c0-10.405-10.746-18.149-32.854-23.676C154.659 2.492 130.716 0 105.34 0 79.965 0 56.021 2.492 37.921 7.017 15.813 12.544 5.066 20.288 5.066 30.693c0 3.85 1.476 7.335 4.45 10.479l68.245 82.777v79.23a7.5 7.5 0 0010.831 6.72l40.075-19.863a7.5 7.5 0 004.169-6.71l.077-59.372 68.254-82.787c2.972-3.143 4.446-6.625 4.446-10.474zM44.94 20.767C61.467 17.048 82.917 15 105.34 15s43.874 2.048 60.399 5.767c18.25 4.107 23.38 8.521 24.607 9.926-1.228 1.405-6.357 5.819-24.607 9.926-16.525 3.719-37.977 5.767-60.399 5.767s-43.873-2.048-60.4-5.766c-18.249-4.107-23.38-8.521-24.607-9.926 1.227-1.406 6.358-5.82 24.607-9.927zm74.691 95.719a7.5 7.5 0 00-1.713 4.761l-.075 57.413-25.081 12.432v-69.835a7.496 7.496 0 00-1.713-4.771L40.306 54.938C58.1 59.1 81.058 61.387 105.34 61.387c24.283 0 47.24-2.287 65.034-6.449l-50.743 61.548z"}})])
          )
        }
      }
    